"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "auth", {
  enumerable: true,
  get: function get() {
    return _oauth["default"];
  }
});
Object.defineProperty(exports, "authorize", {
  enumerable: true,
  get: function get() {
    return _authorize["default"];
  }
});
Object.defineProperty(exports, "authorizeFromArray", {
  enumerable: true,
  get: function get() {
    return _authorize.authorizeFromArray;
  }
});
Object.defineProperty(exports, "authorizeFromRedux", {
  enumerable: true,
  get: function get() {
    return _authorize.authorizeFromRedux;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _oauth["default"];
  }
});
Object.defineProperty(exports, "logout", {
  enumerable: true,
  get: function get() {
    return _logout["default"];
  }
});
Object.defineProperty(exports, "registerLogoutCleanup", {
  enumerable: true,
  get: function get() {
    return _logoutCleanupRegistry.registerLogoutCleanup;
  }
});
Object.defineProperty(exports, "usePermissions", {
  enumerable: true,
  get: function get() {
    return _usePermissions["default"];
  }
});

var _logout = _interopRequireDefault(require("./authentication/logout"));

var _logoutCleanupRegistry = require("./authentication/logout-cleanup-registry");

var _oauth = _interopRequireDefault(require("./authentication/oauth"));

var _authorize = _interopRequireWildcard(require("./authorization/authorize"));

var _usePermissions = _interopRequireDefault(require("./authorization/usePermissions"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }